import { getJson, getObject, postVoid, StringOrNothing, } from "../ChoiceApi"

import { ITimelineVital, ITimelineProgressNote, ITimelineMail, ITimelineMedication, ITimelineImmunization, ITimelineObstetric,
    ITimelineOrderResult, ITimelineDocument, ITimelinePatientReported, ITimelineTelemedicine, ITimelineAuthorizationItems, ITimelineSetup, 
    IFishboneType,
    ITimelineFishboneResult,
    ITimelineCustomResult,
    ITimelineVitalEdit,
    ITimelinePatientResultEdit,
    ITimelineNewResultPayload} from "../Models/EMR/TimelineModel";

export async function setup(): Promise<ITimelineSetup> {
    return (await getJson(`api/EMR/Timeline/setup`)) as ITimelineSetup;
}

export async function vitals(patientId: number): Promise<ITimelineVital[]> {
    return (await getJson(`api/EMR/Timeline/Vitals/${patientId}`)) as ITimelineVital[];
}

export async function progressNotes(patientId: number): Promise<ITimelineProgressNote[]> {
    return (await getJson(`api/EMR/Timeline/ProgressNotes/${patientId}`)) as ITimelineProgressNote[];
}

export async function mail(patientId: number): Promise<ITimelineMail[]> {
    return (await getJson(`api/EMR/Timeline/Mail/${patientId}`)) as ITimelineMail[];
}

export async function medications(patientId: number): Promise<ITimelineMedication[]> {
    return (await getJson(`api/EMR/Timeline/Medications/${patientId}`)) as ITimelineMedication[];
}

export async function immunizations(patientId: number): Promise<ITimelineImmunization[]> {
    return (await getJson(`api/EMR/Timeline/Immunizations/${patientId}`)) as ITimelineImmunization[];
}

export async function obstetrics(patientId: number): Promise<ITimelineObstetric[]> {
    return (await getJson(`api/EMR/Timeline/Obstetrics/${patientId}`)) as ITimelineObstetric[];
}

export async function orderResults(patientId: number): Promise<ITimelineOrderResult[]> {
    return (await getJson(`api/EMR/Timeline/OrderResults/${patientId}`)) as ITimelineOrderResult[];
}

export async function documents(patientId: number): Promise<ITimelineDocument[]> {
    return (await getJson(`api/EMR/Timeline/Documents/${patientId}`)) as ITimelineDocument[];
}

export async function patientReported(patientId: number): Promise<ITimelinePatientReported[]> {
    return (await getJson(`api/EMR/Timeline/PatientReported/${patientId}`)) as ITimelinePatientReported[];
}

export async function telemedicine(patientId: number): Promise<ITimelineTelemedicine[]> {
    return (await getJson(`api/EMR/Timeline/Telemedicine/${patientId}`)) as ITimelineTelemedicine[];
}

export async function authorizations(patientId: number): Promise<ITimelineAuthorizationItems | undefined> {
    return await getObject(`api/EMR/Timeline/Authorizations/${patientId}`);
}

export async function emrSummaryVitals(patientId: number): Promise<ITimelineVital[]> {
    return (await getJson(`api/EMR/Timeline/Vitals/EMRSummary/${patientId}`)) as ITimelineVital[];
}

export async function fishboneTypes(): Promise<IFishboneType[]> {
    return (await getJson(`api/EMR/Timeline/FishboneTypes`)) as IFishboneType[];
}

export async function fishboneResults(patientId: number): Promise<ITimelineFishboneResult[]> {
    return (await getJson(`api/EMR/Timeline/FishboneResults/${patientId}`)) as ITimelineFishboneResult[];
}

export async function customResults(patientId: number): Promise<ITimelineCustomResult[]> {
    return (await getJson(`api/EMR/Timeline/CustomResults/${patientId}`)) as ITimelineCustomResult[];
}

export async function updateVital(vital: ITimelineVitalEdit): Promise<StringOrNothing> {
    return await postVoid(`api/EMR/Timeline/Vitals`, vital);
}

export async function updateFishboneResult(fishboneResult: ITimelinePatientResultEdit): Promise<StringOrNothing> {
    return await postVoid(`api/EMR/Timeline/FishboneResult`, fishboneResult);
}

export async function updateCustomResult(customResult: ITimelinePatientResultEdit): Promise<StringOrNothing> {
    return await postVoid(`api/EMR/Timeline/CustomResult`, customResult);
}

export async function createNewFishboneResult(newResult: ITimelineNewResultPayload): Promise<StringOrNothing> {
    return await postVoid(`api/EMR/Timeline/NewResult/create`, newResult);
}